import { BeanMenu } from './BeanMenu'
import { BeanOperacao } from './BeanOperacao'

export class BeanUsuario{
  constructor(
    public usuaIdCdUsuario			 : string,
    public usuaNmUsuario			 : string,
    public usuaDsRe				     : string,
    public usuaDsLoginDac			 : string,
    public usuaDhRegistro			 : string,
    public usuaDhAdmissao			 : string,
    public usuaNrCargahoraria		 : string,

    public usuaInDesligado		 : string,
    public usuaDhDesligamento		 : string,
    public usuaIdCdGestor			 : string,
    public userGestor			 : BeanUsuario[],

    public usuaDhInativo			 : string,
    public tiusIdCdTipoUsuario			 : string,
     // public BeanTipoUsuario		     : BeanTipoUsuario,
   // public BeanSituacao	             : BeanSituacao,
    public siusIdCdSituacaoUsuario			 : string,
    public usuaInAdmin				 : string,
    //public operation		     : BeanOperacao,
    public operIdCdOperacao		 : string,
    public usuaDsSenha				 : string,
    public usuaDhInicioOperacional  : string,
    public usuaNrCargaHoraria  : string,


    public operations : BeanOperacao[],
    public menus : BeanMenu[],
    public usuaInExcluirFicha : string,

    public isRevogarSenha : boolean
  ){}
}
